import Lenis from 'lenis'

import '../scss/theme.scss';
import mobileMenu from './utils/hcOffcanvasNav';
import lazyload from './utils/lazyload';
import topbarSlider from './components/topbar';
import navAccordion from './components/footer';
import Blocks from './blocks';
import gallery from './components/gallery';
import Smileys from './components/smileys';
import scrollHeader from './components/header';

const blocks = new Blocks;
const smileys = new Smileys;

const lenis = new Lenis({
  autoRaf: true,
});

document.addEventListener('DOMContentLoaded', () => {
  // lenis.on('scroll', (e) => {
  //   console.log(e);
  // });

  scrollHeader();
	lazyload();
  mobileMenu('#menu-header-left', '.hc-menu-toggle');
  topbarSlider();
  navAccordion();
  gallery();
  smileys.init();
  blocks && blocks.init();
})
